<div class="spacing-top"></div>

<div class="main-step">
	<div class="box-menu-settings active">
		<div class="row-box">
			<h4>{{ labels().ROTATION_WORKFLOW_COMPONENT_TITLE }}</h4>
		</div>
		<div class="row-box">
			<div class="box-suggestion">
				<p>
					{{ labels().ROTATION_WORKFLOW_COMPONENT_MESSAGE }}
				</p>
			</div>
		</div>
		<div class="row-box wrapper-img-axis justify-content-center">
			<div class="" [hidden]="!isImgVisible">
				<img [src]="helpImg" alt="" (load)='isImgVisible = true'>
			</div>
		</div>
		<div class="bottom-margin"></div>
		<div class="container-btn-confirm">
			<div class="divider-box"></div>
			<div class="wrapper-btn-confirm">
				<button data-testid="SUBSYS4_ROTATIONWK_CONFIRM_BTN" type="button" class="btn btn-primary px-2"
					(click)="confirm()">
					{{ labels().ROTATION_WORKFLOW_COMPONENT_CONFIRM_BTN }}
				</button>
			</div>
		</div>
	</div>
</div>